/* @flow */
// typecheck: ignore file
import React from 'react';
import { removeFilter, addFilter } from 'reducers/tables';
import Heading from 'components/Heading.jsx';
import Text from 'components/Text.jsx';
import Checkbox from 'components/Checkbox.jsx';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Set } from 'immutable';

import ClickEventTrigger from 'components/ClickEventTrigger.jsx';

import type { Filter } from 'components/SmartTable.jsx';
import type { Filter as FilterType } from 'reducers/tables';

type Props = {
  namespace: string,
  filters: Filter[],

  selectedFilters: Set<string>,
  addFilter: (namespace: string, filter: FilterType) => any,
  removeFilter: (namespace: string, filter: FilterType) => any,
}

class SmartTableFilters extends React.Component {
  props: Props;

  toggleFilter(filterOption: FilterType) {
    const fn = this.props.selectedFilters.get(filterOption.key)
      ? this.props.removeFilter
      : this.props.addFilter;

    fn(this.props.namespace, filterOption);
  }

  renderFilter = (filter: Filter) => {
    const checkboxes = filter.options.map(option =>
      <ClickEventTrigger eventElementName={option.eventElementName}>
        <Checkbox
          name="filter"
          key={option.key}
          label={option.name}
          onChange={() => this.toggleFilter(option)}
          checked={this.props.selectedFilters.has(option.key)}
        />
      </ClickEventTrigger>
    );

    return (
      <div key={filter.name}>
        <Heading level="2">
          <Text size="xsmall" color="thunder" uppercase>
            {filter.name}
          </Text>
        </Heading>
        {checkboxes}
      </div>
    );
  }

  render() {
    return (
      <div>
        <Heading level="1">
          <Text size="medium" weight="semibold">Filter by</Text>
        </Heading>
        {this.props.filters.map(this.renderFilter)}
      </div>
    );
  }
}

// $FlowFixMe
function mapStateToProps(state: Object, props: Props) {
  return {
    selectedFilters: state.tables.get(props.namespace).filters,
  };
}

function mapDispatchToProps(dispatch: Function) {
  // $FlowFixMe
  return bindActionCreators({ removeFilter, addFilter }, dispatch);
}

export { SmartTableFilters };
export default connect(mapStateToProps, mapDispatchToProps)(SmartTableFilters);



// WEBPACK FOOTER //
// ./src/components/SmartTableFilters.jsx